import Component from "./ProjectsCard";
export default Component;
